/**
 * Cuántas filas muestra la bandeja "Hoy" (auditoría UX-12).
 *
 * Con muchos asuntos se muestran los primeros `max` y un "Ver todos", pero
 * lo crítico y lo alto nunca queda escondido: si hay más urgentes que `max`,
 * se muestran todos los urgentes. La lista llega ya ordenada por nivel.
 */
export const MAX_BANDEJA = 8;

export function filasVisibles<T extends { nivel: string }>(
  items: readonly T[],
  expandida: boolean,
  max: number = MAX_BANDEJA,
): T[] {
  if (expandida || items.length <= max) return [...items];
  const urgentes = items.filter((i) => i.nivel === "critica" || i.nivel === "alta").length;
  return items.slice(0, Math.max(max, urgentes));
}
